var _circle, _rect, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.3436,
    cy: 65.3436,
    r: 63.1561,
    fill: "currentColor",
    stroke: "white",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 128,
    height: 128,
    rx: 64,
    stroke: "white",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 65.5,
    y1: 25.5,
    x2: 65.5,
    y2: 105.04,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 64.5,
    x2: 105.04,
    y2: 64.5,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAvatar);
export default __webpack_public_path__ + "static/media/no_avatar.6d13bdcb9d093de1c1650111c1cb4e94.svg";
export { ForwardRef as ReactComponent };